var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.48 12A5.526 5.526 0 0 1 32 17.52v8.96A5.526 5.526 0 0 1 26.48 32h-8.96A5.525 5.525 0 0 1 12 26.48v-8.96A5.526 5.526 0 0 1 17.52 12zm0 1.774h-8.96a3.749 3.749 0 0 0-3.746 3.745v8.962a3.749 3.749 0 0 0 3.745 3.745h8.962a3.75 3.75 0 0 0 3.745-3.745v-8.962a3.75 3.75 0 0 0-3.745-3.745zM22 16.847A5.16 5.16 0 0 1 27.153 22 5.16 5.16 0 0 1 22 27.153 5.16 5.16 0 0 1 16.847 22 5.16 5.16 0 0 1 22 16.847zm0 1.774a3.383 3.383 0 0 0-3.379 3.38A3.383 3.383 0 0 0 22 25.378 3.383 3.383 0 0 0 25.379 22 3.383 3.383 0 0 0 22 18.621zm5.37-3.279c.343 0 .679.138.92.381.243.241.38.577.38.92 0 .342-.137.678-.38.92s-.577.382-.92.382c-.342 0-.678-.14-.92-.381a1.312 1.312 0 0 1-.382-.92 1.306 1.306 0 0 1 1.301-1.301z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIg);
export default __webpack_public_path__ + "static/media/icon-ig.aa5d145bb484ea21094d11ab9350e9de.svg";
export { ForwardRef as ReactComponent };